__turbopack_context__.v({
  "blurb": "EventTile-module-scss-module__9ZhZ3G__blurb",
  "blurbContainer": "EventTile-module-scss-module__9ZhZ3G__blurbContainer",
  "buttonsContainer": "EventTile-module-scss-module__9ZhZ3G__buttonsContainer",
  "contentContainer": "EventTile-module-scss-module__9ZhZ3G__contentContainer",
  "dates": "EventTile-module-scss-module__9ZhZ3G__dates",
  "dropIn": "EventTile-module-scss-module__9ZhZ3G__dropIn",
  "dropInAnimation": "EventTile-module-scss-module__9ZhZ3G__dropInAnimation",
  "eventButton": "EventTile-module-scss-module__9ZhZ3G__eventButton",
  "eventButtonActive": "EventTile-module-scss-module__9ZhZ3G__eventButtonActive",
  "eventButtonSVG": "EventTile-module-scss-module__9ZhZ3G__eventButtonSVG",
  "eventContainer": "EventTile-module-scss-module__9ZhZ3G__eventContainer",
  "image": "EventTile-module-scss-module__9ZhZ3G__image",
  "imgContainer": "EventTile-module-scss-module__9ZhZ3G__imgContainer",
  "line": "EventTile-module-scss-module__9ZhZ3G__line",
  "listContainer": "EventTile-module-scss-module__9ZhZ3G__listContainer",
  "listEvent": "EventTile-module-scss-module__9ZhZ3G__listEvent",
  "listdate": "EventTile-module-scss-module__9ZhZ3G__listdate",
  "listlink": "EventTile-module-scss-module__9ZhZ3G__listlink",
  "listtitle": "EventTile-module-scss-module__9ZhZ3G__listtitle",
  "tileContainer": "EventTile-module-scss-module__9ZhZ3G__tileContainer",
  "title": "EventTile-module-scss-module__9ZhZ3G__title",
  "titleContainer": "EventTile-module-scss-module__9ZhZ3G__titleContainer",
});
